import React, { useEffect } from "react";
import * as style from "./PermissionPanelContent.module.scss";
import Typography from "../Common/CprimeText";
import { Divider, TextArea, TextInput } from "cprime-foundational-components";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/store";
import { setPermissionData } from "../../store/slices/PermissionSlice/permissionSlice";
interface PermissionPanelContentProps {
  isEdit: boolean;
  selectedPermission?: any;
}

const PermissionPanelContent: React.FC<PermissionPanelContentProps> = ({
  isEdit,
  selectedPermission,
}) => {
  const scssClass = style as any;
  // const [permissionIdOptions, setPermissionIdOptions] = useState([]);
  // const [otherPermissionId, setOtherPermissionId] = useState(false);
  const form = useSelector((state: RootState) => state?.permission?.form);
  const dispatch = useDispatch();

  // const getPermissionId = async () => {
  //   try {
  // const response = await getPermissionIdList();
  // const groupTypes = response?.data?.map(
  //   (permission: { permission_id: any; permission_name: any }) => {
  //     return {
  //       id:
  //         permission?.permission_name === "Other"
  //           ? "Other"
  //           : permission?.permission_id,
  //       label: permission?.permission_name,
  //     };
  //   },
  // );
  // setPermissionIdOptions(groupTypes);
  //   } catch (err) {}
  // };

  useEffect(() => {
    if (isEdit && selectedPermission) {
      const permission_id = selectedPermission?.permission_id;
      dispatch(
        setPermissionData({
          permission_id: permission_id || "",
          description: selectedPermission?.description || "",
          specifyPermissionType:
            selectedPermission?.specifyPermissionType || "",
        }),
      );
      // if (selectedPermission?.is_custom) {
      //   setOtherPermissionId(true);
      // }
    } else {
      dispatch(
        setPermissionData({
          specifyPermissionType: "",
          description: "",
        }),
      );
    }
  }, [isEdit, selectedPermission]);

  // useEffect(() => {
  //   getPermissionId();
  // }, []);

  return (
    <div className={scssClass.panelContent}>
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>
        Permission Details
      </Typography>
      <div className={scssClass.fieldsContent}>
        <TextInput
          value={form?.specifyPermissionType}
          className={scssClass.textField}
          //disabled={isEdit}
          sx={{
            width: "100%",
            // "& .MuiInputBase-input": { padding: "0.75rem 1rem" },
            // "& .MuiInputBase-root": { height: "39.98px" },
          }}
          onChange={(e: any) =>
            dispatch(
              setPermissionData({ specifyPermissionType: e?.target?.value }),
            )
          }
          placeholder="Enter Permission Name"
          label="Permission"
        />

        <TextArea
          label={
            <>
              Description
              {/* <span style={{ color: "#c40818" }}>*</span> */}
            </>
          }
          aria-label="minimum height"
          minRows={3}
          placeholder="Enter Description"
          style={{ width: "99.5%" }}
          value={form?.description}
          onChange={(e) =>
            dispatch(setPermissionData({ description: e?.target?.value }))
          }
        />
      </div>
    </div>
  );
};
export default PermissionPanelContent;
